module.exports = __webpack_public_path__ + "static/media/card_suits_club.30e41ba7.png";